import { Youtube as BaseYoutube } from "@tiptap/extension-youtube";

export const Youtube = BaseYoutube.extend({
    controls: false,
    renderText({ node }) {
        return `__%${node.type.name}%${node.attrs.src}%${node.type.name}%__`;
    },
    parseHTML() {
        return [
            {
                tag: "div[data-youtube-video] iframe",
                getAttrs: node => {
                    return !!node?.src && null;
                },
            },
        ];
    },
});
